import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import {
  currencies,
  currenciesList,
} from "../../../shared/currencies/currencies.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

export interface CountryChangeEvent {
  originalEvent: MouseEvent;
  value: string;
}

@Component({
  selector: "app-currency-select",
  templateUrl: "./currency-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class CurrencySelectComponent implements OnInit {
  public readonly currencyChange = output<string>();
  @Input() public currency: string;
  public readonly disabled = input(false);

  public subscription = new Subscription();
  public currencyList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildCurrencyList();
  }

  public onCurrencyChange(event: CountryChangeEvent) {
    this.currencyChange.emit(event.value);
  }

  private buildCurrencyList(): void {
    currenciesList.map((currKey) => {
      this.currencyList.push({
        label: currencies[currKey].label,
        value: currencies[currKey].value,
      });
    });
  }
}
